import {
  FaFacebook, FaInstagram, FaTwitter , FaLinkedin, FaYoutube, FaDribbble,
  FaMapMarkerAlt, FaEnvelope, FaPhone, FaRegCopyright, FaPaperPlane
} from "react-icons/fa";
import { useState } from "react";
import { sendEmailDemo } from "../services/emailService";
import { useToast } from "../contexts/ToastContext";

const Footer = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { showSuccess, showError } = useToast();

  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    
    try {
      const result = await sendEmailDemo(formData, 'contact');
      
      if (result.success) {
        showSuccess('Thank you for your message! I\'ll get back to you soon.', 6000);
        setFormData({ name: '', email: '', message: '' });
      } else {
        showError('Sorry, there was an error. Please try again or email me directly.', 8000);
      }
    } catch (error) {
      showError('Sorry, there was an error. Please try again or email me directly.', 8000);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <footer className="bg-gradient-to-b from-[#0e0e2c] to-[#0A0B2E] text-white px-8 py-12 border-t border-purple-900/30">
      <div className="grid md:grid-cols-3 gap-12 mb-10">
        {/* Branding */}
        <div className="animate-fade-in-up">
          <div className="flex items-center mb-4">
            <div className="text-2xl text-blue-500 font-bold">P</div>
            <h2 className="ml-2 text-2xl font-bold">SABARISAN</h2>
          </div>
          <p className="text-sm text-gray-300 mb-4">
            Front End Developer with 3 years of experience in logistics and supply chain operations. Specialized in PHP development, RESTful API integration, and database management.
          </p>
          <div className="flex space-x-4 text-pink-500 text-lg">
            <FaFacebook className="hover:text-pink-400 transition-colors cursor-pointer transform hover:scale-110" />
            <FaInstagram className="hover:text-pink-400 transition-colors cursor-pointer transform hover:scale-110" />
            <FaTwitter className="hover:text-pink-400 transition-colors cursor-pointer transform hover:scale-110" />
            <FaLinkedin className="hover:text-pink-400 transition-colors cursor-pointer transform hover:scale-110" />
            <FaYoutube className="hover:text-pink-400 transition-colors cursor-pointer transform hover:scale-110" />
            <FaDribbble className="hover:text-pink-400 transition-colors cursor-pointer transform hover:scale-110" />
          </div>
        </div>

        {/* Contact Info */}
        <div className="animate-fade-in-up" style={{ animationDelay: '0.2s' }}>
          <h3 className="font-bold text-lg mb-4">Contact Me</h3>
          <ul className="space-y-3 text-sm text-gray-300">
            <li className="flex items-start hover:text-pink-400 transition-colors">
              <FaMapMarkerAlt className="text-pink-500 mt-1 mr-2" />
               Chennai, India
            </li>
            <li className="flex items-center hover:text-pink-400 transition-colors">
              <FaEnvelope className="text-pink-500 mr-2" />
              <a href="mailto:sabarisandeveloper@gmail.com">sabarisandeveloper@gmail.com</a>
            </li>
            <li className="flex items-center hover:text-pink-400 transition-colors">
              <FaPhone className="text-pink-500 mr-2" />
              <a href="tel:+916383767287">+91 6383767287</a>
            </li>
          </ul>
        </div>

        {/* Contact Form */}
        <div className="animate-fade-in-up" style={{ animationDelay: '0.4s' }}>
          <h3 className="font-bold text-lg mb-4">Send Message</h3>
          <form onSubmit={handleSubmit} className="space-y-4">
            <input
              type="text"
              name="name"
              placeholder="Your Name"
              value={formData.name}
              onChange={handleInputChange}
              required
              className="w-full px-4 py-2 bg-gray-800 text-white rounded-lg border border-gray-600 focus:border-pink-500 focus:outline-none transition-colors"
            />
            <input
              type="email"
              name="email"
              placeholder="Your Email"
              value={formData.email}
              onChange={handleInputChange}
              required
              className="w-full px-4 py-2 bg-gray-800 text-white rounded-lg border border-gray-600 focus:border-pink-500 focus:outline-none transition-colors"
            />
            <textarea
              name="message"
              placeholder="Your Message"
              value={formData.message}
              onChange={handleInputChange}
              required
              rows="3"
              className="w-full px-4 py-2 bg-gray-800 text-white rounded-lg border border-gray-600 focus:border-pink-500 focus:outline-none transition-colors resize-none"
            ></textarea>
            <button
              type="submit"
              disabled={isSubmitting}
              className="w-full bg-pink-600 hover:bg-pink-700 text-white px-4 py-2 rounded-lg transition-colors font-medium flex items-center justify-center disabled:opacity-50"
            >
              {isSubmitting ? (
                <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></div>
              ) : (
                <>
                  <FaPaperPlane className="mr-2" />
                  Send Message
                </>
              )}
            </button>
          </form>
        </div>
      </div>

      {/* Bottom Bar */}
      <hr className="border-gray-600 mb-4" />
      <div className="flex flex-col md:flex-row justify-between items-center text-sm text-gray-400 gap-3">
        <div className="flex items-center space-x-2">
          <FaRegCopyright />
          <span>2026 All Rights Reserved. sabarisandeveloper</span>
        </div>
        <div className="flex items-center space-x-4 text-gray-400">
          <a href="/privacy-policy.html" className="hover:text-pink-400 transition-colors">Privacy Policy</a>
          <span>|</span>
          <a href="/terms.html" className="hover:text-pink-400 transition-colors">Terms & Conditions</a>
        </div>
        <div className="text-pink-400">
          Made with ❤️ by Sabarisan P
        </div>
      </div>
    </footer>
  );
};

export default Footer;
